import React, {useState} from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, flexDirection, minWidth, mt, onDesktop, p, pointer, position, w100} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon, CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {GreyInfoTable} from "../../atoms/GreyInfoTable";
import {CreditModalEvent, ModalEventSource} from "../tracking/analytics/credit_modal_event";
import {CreditCalculatorGTMEvent} from "../tracking/credit_gtm";
import {sendCreditEvent} from "../tracking/send_credit_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";
import {ICreditData, ICreditRatingData} from "../types/ICreditData";
import {getCreditInfo} from "../utils/get_credit_info";
import {CreditCalculatorForm} from "./CreditCalculatorForm";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    submitData: ICreditData | ICreditRatingData;
    gtmEvent?: CreditCalculatorGTMEvent;
    algolyticData: {type: CreditAlgolyticsViewType; source: ModalEventSource};
}

export const CreditApplicationModal = (props: IProps) => {
    const [applicationSuccess, setApplicationSuccess] = useState(false);
    const theme = useTheme();

    const creditInfoTable = getCreditInfo(props.submitData);

    const onClose = (closedByButton?: boolean) => {
        props.onClose();
        if (!applicationSuccess) {
            CreditModalEvent({
                sent: closedByButton ? false : null,
                source_id: props.algolyticData.source,
                view_type: props.algolyticData.type
            });
        }
        setApplicationSuccess(false);
    };

    const onAfterSend = (isSuccess: boolean) => {
        CreditModalEvent({
            sent: true,
            source_id: props.algolyticData.source,
            view_type: props.algolyticData.type
        });

        if (props.gtmEvent) {
            sendCreditEvent(props.gtmEvent);
        }

        if (isSuccess !== applicationSuccess) {
            setApplicationSuccess(isSuccess);
        }
    };

    return (
        <Modal isOpen={props.isOpen} onModalClose={() => onClose()} css={modalStyle}>
            {applicationSuccess ? (
                <>
                    <Modal.Header />
                    <Modal.Content>
                        <div css={successContentStyle} id={CREDIT_PAGES_IDS.COMMON.CREDIT_APPLICATION_MODAL}>
                            <div css={successTextStyle}>
                                <BrandCheckboxCheckedIcon wrapperSize="10" size="10" wrapperColor={theme.colors.primary} />
                                <Text variant="headline_3" as="p">
                                    Twoje zapytanie zostało wysłane
                                </Text>
                            </div>
                            <Button variant="filled_primary" css={w100} onClick={() => onClose()}>
                                ok
                            </Button>
                        </div>
                    </Modal.Content>
                </>
            ) : (
                <>
                    <Modal.Header showCloseButton={false} css={position("relative")}>
                        <div css={mt(2)}>
                            <Text variant="headline_6">Umów się na rozmowę</Text>
                            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                                Skorzystaj z bezpłatnej porady kredytowej
                            </Text>
                            <div onClick={() => onClose(true)} css={closeStyle}>
                                <CloseIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content css={overflowReset}>
                        {creditInfoTable.length > 0 && <GreyInfoTable infoItems={creditInfoTable} />}

                        <CreditCalculatorForm
                            submitData={props.submitData}
                            onAfterSend={onAfterSend}
                            source={CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT}
                        />
                    </Modal.Content>
                </>
            )}
        </Modal>
    );
};

const overflowReset = css`
    overflow: visible;
`;

const modalStyle = css`
    ${overflowReset};
    ${p(2, 0)};

    ${onDesktop(p(2), minWidth("550px"))};
`;

const closeStyle = css`
    ${position("absolute")};
    ${p(2)};
    top: 0;
    right: 0;
    ${pointer};
`;

const successContentStyle = css`
    ${flex("center", "space-between")};
    ${flexDirection("column")};
    gap: ${calculateRemSize(5)};
`;

const successTextStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(2)};
`;
import React, {useState} from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, flexDirection, minWidth, mt, onDesktop, p, pointer, position, w100} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon, CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {GreyInfoTable} from "../../atoms/GreyInfoTable";
import {CreditModalEvent, ModalEventSource} from "../tracking/analytics/credit_modal_event";
import {CreditCalculatorGTMEvent} from "../tracking/credit_gtm";
import {sendCreditEvent} from "../tracking/send_credit_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";
import {ICreditData, ICreditRatingData} from "../types/ICreditData";
import {getCreditInfo} from "../utils/get_credit_info";
import {CreditCalculatorForm} from "./CreditCalculatorForm";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    submitData: ICreditData | ICreditRatingData;
    gtmEvent?: CreditCalculatorGTMEvent;
    algolyticData: {type: CreditAlgolyticsViewType; source: ModalEventSource};
}

export const CreditApplicationModal = (props: IProps) => {
    const [applicationSuccess, setApplicationSuccess] = useState(false);
    const theme = useTheme();

    const creditInfoTable = getCreditInfo(props.submitData);

    const onClose = (closedByButton?: boolean) => {
        props.onClose();
        if (!applicationSuccess) {
            CreditModalEvent({
                sent: closedByButton ? false : null,
                source_id: props.algolyticData.source,
                view_type: props.algolyticData.type
            });
        }
        setApplicationSuccess(false);
    };

    const onAfterSend = (isSuccess: boolean) => {
        CreditModalEvent({
            sent: true,
            source_id: props.algolyticData.source,
            view_type: props.algolyticData.type
        });

        if (props.gtmEvent) {
            sendCreditEvent(props.gtmEvent);
        }

        if (isSuccess !== applicationSuccess) {
            setApplicationSuccess(isSuccess);
        }
    };

    return (
        <Modal isOpen={props.isOpen} onModalClose={() => onClose()} css={modalStyle}>
            {applicationSuccess ? (
                <>
                    <Modal.Header />
                    <Modal.Content>
                        <div css={successContentStyle} id={CREDIT_PAGES_IDS.COMMON.CREDIT_APPLICATION_MODAL}>
                            <div css={successTextStyle}>
                                <BrandCheckboxCheckedIcon wrapperSize="10" size="10" wrapperColor={theme.colors.primary} />
                                <Text variant="headline_3" as="p">
                                    Twoje zapytanie zostało wysłane
                                </Text>
                            </div>
                            <Button variant="filled_primary" css={w100} onClick={() => onClose()}>
                                ok
                            </Button>
                        </div>
                    </Modal.Content>
                </>
            ) : (
                <>
                    <Modal.Header showCloseButton={false} css={position("relative")}>
                        <div css={mt(2)}>
                            <Text variant="headline_6">Umów się na rozmowę</Text>
                            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                                Skorzystaj z bezpłatnej porady kredytowej
                            </Text>
                            <div onClick={() => onClose(true)} css={closeStyle}>
                                <CloseIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content css={overflowReset}>
                        {creditInfoTable.length > 0 && <GreyInfoTable infoItems={creditInfoTable} />}

                        <CreditCalculatorForm
                            submitData={props.submitData}
                            onAfterSend={onAfterSend}
                            source={CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT}
                        />
                    </Modal.Content>
                </>
            )}
        </Modal>
    );
};

const overflowReset = css`
    overflow: visible;
`;

const modalStyle = css`
    ${overflowReset};
    ${p(2, 0)};

    ${onDesktop(p(2), minWidth("550px"))};
`;

const closeStyle = css`
    ${position("absolute")};
    ${p(2)};
    top: 0;
    right: 0;
    ${pointer};
`;

const successContentStyle = css`
    ${flex("center", "space-between")};
    ${flexDirection("column")};
    gap: ${calculateRemSize(5)};
`;

const successTextStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(2)};
`;
